<template>
    <div class="progress_bar">
        <div class="progress_item" v-for="(item,index) in data">
            <!-- state==0:未开始状态；state==1:正在进行状态；state==2:已完成状态；-->
            <div :class="item.state == 0 ? 'progress_item_msg unreaches' :  item.state == 1 ? 'progress_item_msg being' : 'progress_item_msg complete'">
                <div class="progress_state_icon"></div>
                <p class="item_msg_desc">{{ item.name }}</p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "horizontal-timeline",
        props:{
            data:Array
        },
        data() {
            return {

            }
        }
    }
</script>

<style scoped lang="less">

    .progress_bar {
        display: flex;
        margin: 0 auto;
        justify-content: center;

    }

    .progress_bar .progress_item {
        width: 150px;
        height: 1px;
        background: #E0E0E0;

    }

    .progress_bar .progress_item:last-child {
        width: 0;
    }

    .progress_item .progress_item_msg {
        margin-top: -10px;
        margin-left: -20px;
    }

    .progress_item .progress_state_icon {
        width: 20px;
        height: 20px;
    }


    .progress_item .item_msg_desc {
        font-size: 12px;
        color: #323232;
        padding-top: 5px;
        line-height: 17px;
        margin-left: -10px;
        white-space: nowrap;
    }

    .progress_item_msg.complete {
        .progress_state_icon {
            background: url(../../assets/progress_complete.png) no-repeat left center;
            background-size: 100% 100%;
        }
    }

    .progress_item_msg.being {
        .progress_state_icon {
            background: url(../../assets/progress_being.png) no-repeat left center;
            background-size: 100% 100%;
        }
    }

    .progress_item_msg.unreaches {
        .progress_state_icon {
            background: url(../../assets/progress_unreaches.png) no-repeat left center;
            background-size: 100% 100%;
        }

        .item_msg_desc {
            color: #999999;
        }
    }
</style>